<template>
  <b-modal
    id="ModId1"
    ref="modal"
    :title="modalTitle"
    size="xl"
    @ok="sendModalData($event)"
    @cancel="clearModal"
    @hidden="clearModal"
    ok-title="Сохранить"
    ok-variant="success"
    cancel-variant="danger"
    cancel-title="Отменить"
    :no-close-on-backdrop=true
    :ok-disabled="veeErrors.any() || hasEmptyFields || !isFormEdited"
  >
    <b-container fluid v-if="!loading">
      <div class="modal-spinner">
        <b-spinner variant="secondary" label="Loading..."></b-spinner>
        <strong class="mt-3">Загрузка...</strong>
      </div>
    </b-container>
    <b-form ref="form" @submit.stop.prevent="onSubmit" v-else autocomplete="off">
      <b-container fluid>
        <b-row class="upper_info">
          <h5 class="mb-3 mr-auto">Общая информация</h5>
        </b-row>
        <b-row class="pb-3">
          <b-col md="1" class="pl-0">
            <b-form-group
              label="org_id *"
              label-for="org_id-input"
              label-class="mf-label"
              :invalid-feedback="getError('org_id-input')"
            >
              <b-form-input
                id="org_id-input"
                name="org_id"
                v-validate="modelValidation.org_id"
                data-vv-as="org_id"
                v-model="model.p_org_id"
                placeholder="org_id"
                :disabled="(modalType === 'edit') && !this.isBillingAdmin()"
                :state="validateState('org_id-input')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group
              label="ОПФ *"
              label-for="opf"
              label-class="mf-label"
              :invalid-feedback="getError('opf')"
            >
              <treeselect id="opf"
                          name="opf"
                          :options="selects"
                          v-model="model.p_opf"
                          placeholder="Выбрать..."
                          noResultsText="Ничего не найдено..."
                          :clearable=true
                          label="ОПФ *"
                          :disabled="(modalType === 'edit') && !this.isBillingAdmin()"
                          data-vv-as="ОПФ"
                          v-validate="{required:true}"
              >
                <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col md="3" class="">
            <b-form-group
              label="Наименование организации *"
              label-for="fullname-input"
              label-class="mf-label"
              :invalid-feedback="getError('fullname-input')"
            >
              <b-form-input
                id="fullname-input"
                name="fullname-input"
                v-validate="modelValidation.fullname"
                data-vv-as="Наименование"
                :disabled="(modalType === 'edit') && !this.isBillingAdmin()"
                v-model="model.p_fullname"
                placeholder="Наименование организации"
                :state="validateState('fullname-input')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2" class="">
            <b-form-group
              label="ИНН *"
              label-for="inn-input"
              label-class="mf-label"
              :invalid-feedback="getError('inn-input')"
            >
              <b-form-input
                id="inn-input"
                name="inn-input"
                v-validate="modelValidation.inn"
                v-model="model.p_inn"
                data-vv-as="ИНН"
                :disabled="(modalType === 'edit') && !this.isBillingAdmin()"
                :placeholder="innPlaceholder"
                :state="validateState('inn-input')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group
              :label="kppData.label"
              label-for="kpp-input"
              label-class="mf-label"
              :invalid-feedback="getError('kpp-input')"
            >
              <b-form-input
                id="kpp-input"
                name="kpp-input"
                data-vv-as="КПП"
                v-validate="kppData.validation"
                v-model="model.p_kpp"
                :disabled="(modalType === 'edit') && !this.isBillingAdmin()"
                :placeholder="kppData.placeholder"
                :state="validateState('kpp-input')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2" class="pr-0">
            <b-form-group
              label="Регион работы"
              label-for="region-input"
              label-class="mf-label"
              :invalid-feedback="getError('region-input')"
            >
              <b-form-input
                id="region-input"
                name="region-input"
                v-validate="modelValidation.fullname"
                data-vv-as="Регион работы"
                v-model="model.p_region"
                placeholder="Регион работы"
                :state="validateState('region-input')"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3" class="pl-0">
            <b-form-group
              label="Дилер"
              label-for="dealer"
              label-class="mf-label"
              :invalid-feedback="getError('dealer')"
            >
              <treeselect id="dealer"
                          name="dealer"
                          :options="dealers"
                          v-model="model.p_parent"
                          noResultsText="Ничего не найдено..."
                          :clearable=true
                          placeholder="Выбрать..."
                          :disabled="(modalType === 'edit') && !this.isBillingAdmin()"
                          label="Дилер"
                          data-vv-as="Дилер"
                          v-validate="{required:true}"
              >
                <div slot="value-label" slot-scope="{ node }">{{ node.raw.name }}</div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col v-if="hasSelectBillingTypesRight()" md="3" class="">
            <b-form-group
              label="Тип биллинга *"
              label-for="billing_type"
              label-class="mf-label"
              :invalid-feedback="getError('billing_type')">
              <b-form-select id="billing_type"
                             name="billing_type"
                             :options="billingItems"
                             v-model="model.p_billing_type_id">
                <template #first>
                  <b-form-select-option :value="null" disabled>Тип биллинга</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3" class="pl-0">
            <b-form-group
              label="Сервер *"
              label-for="server"
              label-class="mf-label"
              :invalid-feedback="getError('server')">
              <b-form-select id="server"
                             name="server"
                             :options="serverItems"
                             :disabled="modalType === 'edit'"
                             v-model="model.p_piportal_alias">
                <template #first>
                  <b-form-select-option :value="null" disabled>Выбрать...</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <h5 class="my-3">Контактная информация</h5>
        </b-row>
        <b-row v-for="(item, index) in model.p_contacts" :key="index">
          <b-col md="4" class="pl-0">
            <b-form-group
              label="Контактное лицо"
              label-for="contact-person-input"
              label-class="mf-label"
            >
              <b-form-input
                id="contact-person-input"
                v-model="item.name"
                placeholder="Контактное лицо"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="">
            <b-form-group
              label="Email"
              label-for="contact-email-input"
              label-class="mf-label"
            >
              <b-form-input
                id="contact-email-input"
                v-model="item.email"
                placeholder="Email"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="pr-0">
            <b-form-group
              label="Телефоны"
              label-for="contact-phones-input"
              label-class="mf-label"
            >
              <b-form-input
                id="contact-phones-input"
                v-model="item.phone"
                placeholder="Телефоны"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" class="pr-0 text-right">
            <b-button :disabled="tooManyContacts" size="sm" @click="addContact" variant="outline-secondary" class="mr-2"><i class="fas fa-plus mr-1"></i>Добавить контактное лицо</b-button>
            <b-button size="sm" @click="removeContact" variant="outline-secondary"><i class="fas fa-minus"></i></b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { validation } from './validation'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'Dealer',
  components: {
    Treeselect
  },
  mixins: [validation],
  data () {
    return {
      model: {
        p_id: null,
        p_gid: null,
        p_parent: null,
        p_piportal_alias: null,
        p_billing_type_id: null,
        p_fullname: '',
        p_inn: '',
        p_kpp: '',
        p_org_id: '',
        p_opf: '',
        p_region: '',
        p_contacts: [
          {
            name: '',
            email: '',
            phone: ''
          }
        ]
      },
      loading: null,
      sendMethod: null,
      selects: null,
      modalTitle: '',
      modalType: null,
      dealersSelects: null
    }
  },
  watch: {
    modalParamsDealer () {
      this.model = JSON.parse(JSON.stringify(this.modalParamsDealer))
    },
    groupDropdowns (val) {
      this.selects = val.p_opf
    },
    dealers (val) {
      this.dealersSelects = val.map((item) => {
        item.label = item.name
        return item
      })
    }
  },
  computed: {
    tooManyContacts () {
      return this.model.p_contacts.length > 4
    },
    innPlaceholder () {
      if (this.model.p_opf === 'ИП') {
        return '12 цифр'
      } else {
        return '10 цифр'
      }
    },
    kppData () {
      if (this.model.p_opf === 'ИП') {
        return {
          placeholder: 'Необязательно',
          label: 'КПП',
          validation: {
            required: false
          }
        }
      } else {
        return {
          placeholder: '9 цифр',
          label: 'КПП *',
          validation: {
            required: true,
            digits: 9
          }
        }
      }
    },
    billingItems () {
      return this.billingTypes?.map(({ id, caption }) => ({ value: id, text: caption }))
    },
    serverItems () {
      return this.userInfo.piportals?.map(({ name, alias }) => ({ value: alias, text: name }))
    },
    ...mapState(
      {
        billingTypes: state => state.groupsUsers.billingTypes,
        userInfo: state => state.authorization.userInfo,
        groupDropdowns: state => state.groupsUsers.groupDropdowns,
        modalParamsDealer: state => state.dealers.modalParamsDealer,
        dealers: state => state.dealers.dealers
      }
    ),
    hasEmptyFields () {
      if (this.model.p_opf === 'ИП') {
        return !this.model.p_opf ||
          !this.model.p_org_id ||
          !this.model.p_fullname ||
          !this.model.p_billing_type_id ||
          !this.model.p_piportal_alias ||
          !this.model.p_inn
      } else {
        return !this.model.p_opf ||
          !this.model.p_fullname ||
          !this.model.p_org_id ||
          !this.model.p_billing_type_id ||
          !this.model.p_piportal_alias ||
          !this.model.p_inn ||
          !this.model.p_kpp
      }
    },
    isFormEdited () {
      let isChanged = false
      if (this.modalType === 'edit') {
        for (const key in this.model) {
          if (key === 'p_contacts') {
            for (const i in this.model.p_contacts) {
              for (var propertyName in this.model.p_contacts[i]) {
                if (!this.modalParamsDealer.p_contacts[i] || this.model.p_contacts[i][propertyName] !== this.modalParamsDealer.p_contacts[i][propertyName]) {
                  isChanged = true
                }
              }
            }
          } else if (this.modalParamsDealer && key in this.modalParamsDealer && this.model[key] !== this.modalParamsDealer[key]) {
            isChanged = true
          }
        }
      } else {
        isChanged = true
      }
      return isChanged
    }
  },
  methods: {
    isBillingAdmin () {
      const hasRights = this.userInfo.rights.filter(item => {
        return item === 'billing_admin'
      })
      return (hasRights.length > 0)
    },
    addContact () {
      this.model.p_contacts.push({
        name: '',
        email: '',
        phone: ''
      })
    },
    removeContact () {
      if (this.model.p_contacts.length > 1) {
        this.model.p_contacts.splice((this.model.p_contacts.length - 1), 1)
      }
    },
    modalDealer (data) {
      this.modalType = 'add'
      this.getGroupDropdowns(data)
      if (data.add) {
        this.modalTitle = 'Добавление дилера'
        this.$root.$emit('bv::show::modal', 'ModId1', event)
        this.loading = true
        this.sendMethod = 'create'
        this.model.p_piportal_alias = data.server
      } else {
        this.modalTitle = 'Редактирование дилера'
        this.modalType = 'edit'
        this.$root.$emit('bv::show::modal', 'ModId1', event)
        this.getDealerModalParams(data).then(
          () => {
            this.loading = true
            this.sendMethod = 'edit'
          }
        )
      }
    },
    sendLogic () {
      if (this.sendMethod === 'create') {
        this.loading = false
        this.createDealer(this.model).then(
          () => {
            this.loading = true
            this.$emit('reloadDealers')
            this.$emit('goToFirstPage')
            this.$root.$emit('bv::hide::modal', 'ModId1', event)
          },
          (error) => {
            this.loading = true
            console.log(error)
            this.$root.$emit('bv::hide::modal', 'ModId1', event)
          }
        )
      } else if (this.sendMethod === 'edit') {
        this.loading = false
        this.editDealer(this.model).then(
          () => {
            this.loading = true
            this.$emit('reloadDealers')
            this.$root.$emit('bv::hide::modal', 'ModId1', event)
          },
          (error) => {
            this.loading = true
            console.log(error)
            this.$root.$emit('bv::hide::modal', 'ModId1', event)
          }
        )
      }
    },
    sendModalData (event) {
      event.preventDefault()
      this.sendLogic()
    },
    clearModal () {
      for (const key in this.model) {
        this.model[key] = null
      }
      this.model.p_contacts = [
        {
          name: '',
          email: '',
          phone: ''
        }
      ]
      this.selects = null
      this.loading = false
      this.sendMethod = null
    },
    hasSelectBillingTypesRight () {
      const hasRights = this.userInfo.rights.filter(item => {
        return item === 'select_billing_types'
      })
      return (hasRights.length > 0)
    },
    ...mapActions({
      createDealer: 'dealers/createDealer',
      editDealer: 'dealers/editDealer',
      getGroupDropdowns: 'groupsUsers/getGroupDropdowns',
      getDealerModalParams: 'dealers/getDealerModalParams'
    })
  }
}
</script>

<style scoped>
  .inline {
    display: inline-flex;
  }

  .upper_info {
    align-items: center;
  }

  .form-control:disabled  {
    background-color: #f9f9f9;
    opacity: 1;
  }

  .custom-select:disabled  {
    background-color: #f9f9f9;
    opacity: 1;
  }

  .form-control::placeholder {
    font-size: 14px;
    color: #90A4AE;
    line-height: 20px;
  }

  input.form-control {
    font-size: 14px;
    line-height: 20px;
  }

  textarea.form-control {
    font-size: 14px;
    line-height: 20px;
  }
</style>
